export const headerLinks = [
    { name: "Inicio", href: "/", },
    { name: "Nuestros Productos", href: "/sellos-de-seguridad" },
    { name: "Nosotros", href: "/nosotros" },
    { name: "Preguntas Frecuentes", href: "/preguntas-frecuentes" },
    { name: "Promociones", href: "/promociones" },
    { name: "Contacto", href: "#footer-quality-seal" },
];